import {Rental} from '../../../common/types/rental'
import {formatISO, getTimeDifferenceInMinutes} from '../../../common/utils/dateUtils'

export interface NotStoppedRental {
  id: string
  rentStart: Rental['rentStart']
}

const moreThanMaxRentTimeSinceStart = (rentStart: string, maxRentTimeInMinutes: number): boolean => {
  const timeDifferenceInMinutes = getTimeDifferenceInMinutes(rentStart, formatISO(new Date()))
  return !!timeDifferenceInMinutes && timeDifferenceInMinutes > maxRentTimeInMinutes
}

export const createNotStoppedRentalsData = (rentals: Rental[]): NotStoppedRental[] => {
  const notStoppedRentals: NotStoppedRental[] = []
  rentals.forEach((rental) => {
    if (rental.rentEnd === undefined && moreThanMaxRentTimeSinceStart(rental.rentStart, rental.maxRentTimeInMinutes)) {
      notStoppedRentals.push({
        id: rental.id,
        rentStart: rental.rentStart,
      })
    }
  })
  return notStoppedRentals
}
